import React from 'react';
import { Box } from '@mui/material';
import { keyframes } from '@mui/material/styles';

// X roja animada (referencia react-hot-toast): círculo rojo que hace pop rotado 45° y dos
// líneas blancas perpendiculares que aparecen escalonadas formando la X.
const circleIn = keyframes`
  from { transform: scale(0) rotate(45deg); opacity: 0; }
  to { transform: scale(1) rotate(45deg); opacity: 1; }
`;

const firstLine = keyframes`
  from { transform: scale(0); opacity: 0; }
  to { transform: scale(1); opacity: 1; }
`;

const secondLine = keyframes`
  from { transform: scale(0) rotate(90deg); opacity: 0; }
  to { transform: scale(1) rotate(90deg); opacity: 1; }
`;

const lineBase = {
  content: '""',
  position: 'absolute',
  bottom: '9px',
  left: '4px',
  width: 12,
  height: 2,
  borderRadius: '3px',
  backgroundColor: '#FFFFFF',
  opacity: 0
};

function AnimatedErrorIcon() {
  return (
    <Box
      aria-hidden
      sx={{
        width: 20,
        height: 20,
        flex: 'none',
        borderRadius: '10px',
        bgcolor: 'toast.error',
        opacity: 0,
        transform: 'scale(0) rotate(45deg)',
        animation: `${circleIn} 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275) forwards`,
        animationDelay: '100ms',
        position: 'relative',
        '&::after': {
          ...lineBase,
          animation: `${firstLine} 0.15s ease-out forwards`,
          animationDelay: '150ms'
        },
        '&::before': {
          ...lineBase,
          animation: `${secondLine} 0.15s ease-out forwards`,
          animationDelay: '180ms'
        }
      }}
    />
  );
}

export default AnimatedErrorIcon;
